import FilmsList from './films-list';

export default FilmsList;
